import axios from 'axios';
import { CalculationStatus } from '../../../types/calculation-status.type';

// GET
// /ewosapi/v1/planandprognosis/site/{globalSiteId}/fishgroup/{fishGroupId}/calculationstatus
export const getFishGroupCalculationStatus = async (globalSiteId: string, fishGroupId: string): Promise<CalculationStatus> => {
  const res = await axios.get<CalculationStatus>(
    `/ewosapi/v1/planandprognosis/site/${globalSiteId}/fishgroup/${fishGroupId}/calculationstatus`
  );
  return res.data;
};
